import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not typesafe yet }}\n<div data-test-hero-banner-action ...attributes>\n  {{yield}}\n</div>")